/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class EmailSuppressionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Look up SendGrid suppression status for one or more emails.
     * Supports semicolon-delimited multiple addresses, matching the legacy Command Center tool.
     * @returns any OK
     * @throws ApiError
     */
    public getEmailSuppressions({
        email,
        types
    }: {
        /**
         * One email address, or several separated by semicolons
         */
        email: string
        /**
         * Suppression types to check. Defaults to all: asm, blocks, bounces, spam_reports, invalid_emails
         */
        types?: Array<'asm' | 'blocks' | 'bounces' | 'spam_reports' | 'invalid_emails'>
    }): CancelablePromise<{
        data: Record<string, any>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-suppressions',
            query: {
                email: email,
                types: types
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Remove a single suppression for an email address.
     * @returns void
     * @throws ApiError
     */
    public deleteEmailSuppression({
        type,
        email
    }: {
        /**
         * Suppression type
         */
        type: 'asm' | 'blocks' | 'bounces' | 'spam_reports' | 'invalid_emails'
        email: string
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/email-suppressions/{type}',
            path: {
                type: type
            },
            query: {
                email: email
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Check SendGrid suppression status for this organization's own user emails.
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationEmailSuppressions({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: Record<string, any>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/email-suppressions',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
